import React, { createContext, useContext, useReducer } from 'react';

import { finleyAssert } from '@finley-technologies/common';

import {
  fundingRequestInitialState,
  fundingRequestReducer,
  setFundingRequestWithFullDetailsAndConstraint,
} from '~/borrower/domains/fundingRequests/ui/manage/Reducer';
import { useGetFundingRequestWithFullDetailsAndConstraintQuery } from '~/packages/funding-requests/requests/requests.gql.generated';

/**
 * TODO: Name of this method is unclear
 */
const useFundingRequestValue = (
  fundingRequestId: string,
  borrowerKey: string,
) => {
  // This code block will run every time theres' any changes in State
  const [state, dispatch]: any = useReducer(
    fundingRequestReducer,
    { borrowerKey },
    fundingRequestInitialState,
  );

  const {
    loading,
    error,
  } = useGetFundingRequestWithFullDetailsAndConstraintQuery({
    variables: { fundingRequestId },
    onCompleted: (data) => {
      // This interiror code block will only run once after obtaining data successfully from server
      dispatch(setFundingRequestWithFullDetailsAndConstraint(data));
    },
  });

  // NOTE: constraints is a READONLY, thus separately from `state`, but provided as a part of context
  return {
    fundingRequestId,
    state,
    dispatch,
    isLoading: loading,
    error,
  };
};

// Create context
const FundingRequestsContext = createContext(
  {} as ReturnType<typeof useFundingRequestValue>,
);

export const useFundingRequestContext = () => {
  const context = useContext(FundingRequestsContext);
  finleyAssert(
    context && 'fundingRequestId' in context,
    'useFundingRequestContext was used outside of its Provider',
  );
  return context;
};

// Provider component
export const FundingRequestsProvider = ({
  children,
  fundingRequestId,
  borrowerKey,
}: {
  children: any;
  fundingRequestId: string;
  borrowerKey: string;
}) => {
  return (
    <FundingRequestsContext.Provider
      value={useFundingRequestValue(fundingRequestId, borrowerKey)}
    >
      {children}
    </FundingRequestsContext.Provider>
  );
};
